/**
 *Function will work when the variant of the product will be changed
 */

/**
 *
 */
function afterProductVaraintChange() {
  // eslint-disable-next-line func-names
  document.addEventListener('product:variant-change', function (evt) {
    const isAvailable = evt.detail.variant.available;
    const isComparedPrice = evt.detail.variant.compare_at_price;
    const iconInfo = document.querySelector('.product__details  .icon.icon-new.icon-info');
    const available = document.querySelector('.product__callouts-item.available');
    const notAvailable = document.querySelector('.product__callouts-item.not_available');

    if (iconInfo !== null) {
      if (isComparedPrice != null) {
        iconInfo.classList.remove('hidden');
      } else {
        iconInfo.classList.add('hidden');
      }
    }

    if (isAvailable) {
      if (notAvailable) {
        notAvailable.classList.add('hidden');
      }
      if (available) {
        available.classList.remove('hidden');
      }
    } else {
      if (notAvailable) {
        notAvailable.classList.remove('hidden');
      }
      if (available) {
        available.classList.add('hidden');
      }
    }

    /**
     * @param list
     * @param img
     */
    const checkVariant = (list, img, desktop) => {
      if (!img) {
        list.forEach((element) => {
          if (element !== null) {
            element.classList.add('hidden');
            const tableProductId = element.dataset.productId;
            if (tableProductId === evt.detail.variant.id.toString()) {
              element.classList.remove('hidden');
            }
          }
        });
      } else {
        list.forEach((element) => {
          if (element !== null) {
            element.classList.add('hidden');
            const tableProductId = element.dataset.productId;
            if (tableProductId === evt.detail.variant.id.toString()) {
              element.classList.remove('hidden');
              if (desktop) {
                if (!element.classList.contains('packshot-pict-desktop')) {
                  element.classList.add('hidden');
                }
              }
            }
          }
        });
      }
    };

    /**
     * @param url
     */
    const checkImageUrl = (url) => {
      const imgsEnd = ['.jpg', '.webp', '.png'];
      const imgEnd = url.substring(url.lastIndexOf('.')).toLowerCase();
      return imgsEnd.includes(imgEnd);
    };

    // PDP tables change
    const tablesWrappers = document.querySelectorAll('.accordion__table-wrapper');
    checkVariant(tablesWrappers);

    // PDP lists change
    const listsWrappers = document.querySelectorAll('.accordion__list');
    checkVariant(listsWrappers);

    // PDP attributes change
    const attributesWrapper = document.querySelectorAll('.accordion__attributes');
    checkVariant(attributesWrapper);

    // PDP manufacturing text

    const manufacturingText = document.querySelectorAll('.accordion__box-content--manufacturing');
    checkVariant(manufacturingText);

    // PDP variant summary changes

    const productSummarys = document.querySelectorAll('.product-variant-summary');
    checkVariant(productSummarys);

    // PDP additional info text changes

    const additionalInfoTextWrapper = document.querySelectorAll('.accordion__box-content--additionalInfo');
    checkVariant(additionalInfoTextWrapper);

    // PDP 3 attributes changes under product title
    const attributesProductBox = document.querySelectorAll('.product__attributes-list');
    checkVariant(attributesProductBox);

    // PDP product info image

    const infoImages = document.querySelectorAll('.packshot-produkt-info');
    checkVariant(infoImages);
    const infoImagesPresenter = document.querySelectorAll('.packshot-produkt-info-presenter');
    checkVariant(infoImagesPresenter);

    // PDP information text changes
    const informationTexts = document.querySelectorAll('.accordion-information-text');
    checkVariant(informationTexts);

    // PDP cosmetics quality logos changes in variant
    const cosmeticsQualityLogos = document.querySelectorAll('.product__quality-logos');
    checkVariant(cosmeticsQualityLogos);

    // PDP cosmetics key fact changes
    const keyFactElement = document.querySelectorAll('.accordion__key-fact');
    checkVariant(keyFactElement);

    // PDP cosmtetics information img changes
    const infoImgCosmetics = document.querySelectorAll('.accordion__info-img-wrapper');
    checkVariant(infoImgCosmetics);

    // PDP cosmetics application images changes
    const applicationImgWrapper = document.querySelectorAll('.accordion__application-wrapper');
    checkVariant(applicationImgWrapper);

    // PDP cosmetics application text changes
    const applicationText = document.querySelectorAll('.accordion__application-text');
    checkVariant(applicationText);

    // PDP cosmetics Expert tip changes
    const expertTipWrapper = document.querySelectorAll('.accordion__expertTipWrapper');
    checkVariant(expertTipWrapper);

    // PDP cosmetics subline with bullets changes
    const cosmeticsSubline = document.querySelectorAll('.cosmetics-subline-bullets');
    checkVariant(cosmeticsSubline);

    // PDP cosmtetics information image change
    const cosmeticsInfoImg = document.querySelectorAll('.accordion__image-info-wrapper');
    checkVariant(cosmeticsInfoImg);

    // PDP certification pdf change
    const productCertificationPdf = document.querySelectorAll('.accordion__download-link');
    checkVariant(productCertificationPdf);

    // PDP variant ingredients text changes
    const ingredientsText = document.querySelectorAll('.accordion__ingredients-text');
    checkVariant(ingredientsText);

    // PDP variant article description and text change
    const articleTextDescriptionwrapper = document.querySelectorAll('.accordion__box-title--article-description-and-label-text');
    checkVariant(articleTextDescriptionwrapper);

    // PDP variant consumption doese change
    const consumptionDoseText = document.querySelectorAll('.accordion__box-content--consumption-dose-text');
    checkVariant(consumptionDoseText);

    // PDP quality de certyfication variant changes
    const qualityImgDe = document.querySelectorAll('.quality-de');
    checkVariant(qualityImgDe);

    // PDP quality eu certyfication variant changes
    const qualityImgEu = document.querySelectorAll('.quality-eu');
    checkVariant(qualityImgEu);

    // quick view img changes
    const imgQuickView = document.querySelectorAll('.quickview-image');
    checkVariant(imgQuickView);

    // quick view link to product changes
    const productLink = document.querySelectorAll('.quick-view-view-product-details-link');
    checkVariant(productLink);

    // PDP q&a changes

    const qa1 = document.querySelectorAll('.qa1');
    checkVariant(qa1);
    const qa2 = document.querySelectorAll('.qa2');
    checkVariant(qa2);
    const qa3 = document.querySelectorAll('.qa3');
    checkVariant(qa3);
    const qa4 = document.querySelectorAll('.qa4');
    checkVariant(qa4);
    const qa5 = document.querySelectorAll('.qa5');
    checkVariant(qa5);
    const qa6 = document.querySelectorAll('.qa6');
    checkVariant(qa6);

    // PDP gallery thumbnails changes
    const packageImgThumbnails = document.querySelectorAll('.packshot-pict');
    checkVariant(packageImgThumbnails);
    const labelImgThumbnails = document.querySelectorAll('.label-pict');
    checkVariant(labelImgThumbnails);
    const presenterImgThumbnails = document.querySelectorAll('.presenter-pic');
    checkVariant(presenterImgThumbnails);
    const environmentImgThumbnails = document.querySelectorAll('.environment-pict');
    checkVariant(environmentImgThumbnails);
    const rangeImgThumbnails = document.querySelectorAll('.range-pict');
    checkVariant(rangeImgThumbnails);

    // PDP gallery images desktop changes
    const packageImgDesktop = document.querySelectorAll('.packshot-pict-desktop');
    checkVariant(packageImgDesktop, true, true);
    const labelImgDesktop = document.querySelectorAll('.label-pict-desktop');
    checkVariant(labelImgDesktop, true, true);
    const presenterImgDesktop = document.querySelectorAll('.presenter-pict-desktop');
    checkVariant(presenterImgDesktop, true, true);
    const environmentImgDesktop = document.querySelectorAll('.environment-pict-desktop');
    checkVariant(environmentImgDesktop, true, true);
    const rangeImgDesktop = document.querySelectorAll('.range-pict-desktop');
    checkVariant(rangeImgDesktop, true, true);

    // PDP gallery images mobile changes
    const packageImgMobile = document.querySelectorAll('.packshot-pict-mobile');
    checkVariant(packageImgMobile, true);
    const labelImgMobile = document.querySelectorAll('.label-pict-mobile');
    checkVariant(labelImgMobile, true);
    const presenterImgMobile = document.querySelectorAll('.presenter-pict-mobile');
    checkVariant(presenterImgMobile, true);
    const environmentImgMobile = document.querySelectorAll('.environment-pict-mobile');
    checkVariant(environmentImgMobile, true);
    const rangeImgMobile = document.querySelectorAll('.range-pict-mobile');
    checkVariant(rangeImgMobile, true);
  });
}

window.addEventListener('DOMContentLoaded', () => {
  afterProductVaraintChange();
});
